import { Body } from 'component-library/components/typography/Body';
import { Heading } from 'component-library/components/typography/Heading';
import { Screen } from 'component-library/components/wrappers/ShowOn';
import { colors } from 'component-library/styles/colors';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import styled from 'styled-components';

import { body, heading } from './content';
import { Option, OptionVariant } from './Option';
import { OptionsWrapper } from './OptionsWrapper';

const Wrapper = styled.div`
  padding: 24px;
  margin-bottom: 32px;
`;

export const OptionsSmall = () => (
  <OptionsWrapper screens={[Screen.Sm, Screen.Md]}>
    <Wrapper>
      <StaticImage src="../images/options.webp" alt="smiling-man" width={190} />
      <Heading
        variant={4}
        marginBottom={16}
        marginTop={32}
        color={colors.white}
      >
        {heading}
      </Heading>
      <Body variant={3} marginBottom={32} color={colors.white}>
        {body}
      </Body>
      <Option optionVariant={OptionVariant.SocialSecurity} marginBottom={32} />
      <Option optionVariant={OptionVariant.HealthCare} marginBottom={32} />
      <Option optionVariant={OptionVariant.Taxes} marginBottom={32} />
      <Option optionVariant={OptionVariant.Housing} marginBottom={32} />
      <Option optionVariant={OptionVariant.LegacyGoals} marginBottom={32} />
      <Option optionVariant={OptionVariant.Lifestyle} />
    </Wrapper>
  </OptionsWrapper>
);
